module.exports = __webpack_public_path__ + "img/r_2.00897040.gif";